import React, { useState } from 'react';
import { Typography, Form, Input, Button, Divider, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const CustomizableButtonsForm = props => {
  const { buttons, event, handleSubmitCustomization, isLoading } = props;
  const [buttonList, setButtonList] = useState(
    buttons.length !== 0
      ? [...buttons]
      : [
          {
            Title: '',
            Body: '',
            Icon: '',
            Url: '',
          },
        ]
  );

  const handleSubmit = buttons => {
    console.log(buttons);
    handleSubmitCustomization(event, buttons);
  };

  const initialValues = {
    buttons: buttonList,
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: 3 }}
      wrapperCol={{ span: 12 }}
      initialValues={initialValues}
      onFinish={val => handleSubmit(val)}
    >
      <Form.List name="buttons">
        {(fields, { add, remove }) => (
          <React.Fragment>
            {fields.map((field, index) => (
              <ButtonFieldsItem
                key={field.key}
                field={field}
                value={initialValues.buttons[index]}
                remove={remove}
              />
            ))}
            <Form.Item wrapperCol={{ offset: 3, span: 12 }}>
              <Button
                onClick={() =>
                  add({
                    Title: '',
                    Body: '',
                    Icon: '',
                    Url: '',
                  })
                }
                icon={<PlusOutlined />}
              >
                Add Customizable Button
              </Button>
            </Form.Item>
            <Divider />
          </React.Fragment>
        )}
      </Form.List>
      <Form.Item wrapperCol={{ offset: 3, span: 12 }}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Save Changes
        </Button>
      </Form.Item>
    </Form>
  );
};

const ButtonFieldsItem = props => {
  const { field, remove, value } = props;

  const [title, setTitle] = useState(value ? value.Title : '');

  const handleChange = e => {
    setTitle(e.target.value);
  };

  return (
    <div key={field.key}>
      <Form.Item
        wrapperCol={{ offset: 14, span: 12 }}
        style={{ marginBottom: -32 }}
      >
        <Popconfirm
          placement="rightBottom"
          title={`Are you sure you want to delete ${
            title ? `Button (${title})` : 'Untitled Button'
          }?`}
          okText="Yes"
          cancelText="Cancel"
          onConfirm={() => remove(field.name)}
        >
          <Button type="link" icon={<DeleteOutlined />} />
        </Popconfirm>
      </Form.Item>
      <Typography.Title level={4}>
        {title ? `Button (${title})` : 'Untitled Button'}{' '}
      </Typography.Title>
      <Form.Item
        label="Title"
        name={[field.name, 'Title']}
        fieldKey={[field.fieldKey, 'Title']}
        rules={[{ required: true, message: 'Button title is required.' }]}
      >
        <Input type="text" name="Title" onChange={handleChange} />
      </Form.Item>
      <Form.Item
        label="Body"
        name={[field.name, 'Body']}
        fieldKey={[field.fieldKey, 'Body']}
        rules={[{ required: true, message: 'Button body is required.' }]}
      >
        <Input type="text" name="Body" />
      </Form.Item>
      <Form.Item
        label="Icon"
        name={[field.name, 'Icon']}
        fieldKey={[field.fieldKey, 'Icon']}
        rules={[{ required: true, message: 'Button icon is required.' }]}
      >
        <Input type="text" name="Icon" />
      </Form.Item>
      <Form.Item
        label="Url"
        name={[field.name, 'Url']}
        fieldKey={[field.fieldKey, 'Url']}
        rules={[{ required: true, message: 'Button url is required.' }]}
      >
        <Input type="text" name="Url" />
      </Form.Item>
    </div>
  );
};

// return (
//   <Form
//     name="basic"
//     labelCol={{ span: 3 }}
//     wrapperCol={{ span: 12 }}
//     initialValues={{ remember: true }}
//     onFinish={() =>
//       handleSubmitCustomization(event, { buttonOne, buttonTwo })
//     }
//   >
//     {/* Button 1 */}
//     <Typography.Title level={4}>Button 1</Typography.Title>
//     <Form.Item label="Button Title" name="TitleOne">
//       <Input
//         type="text"
//         name="Title"
//         onChange={e =>
//           setButtonOne({ ...buttonOne, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonOne.Title}
//         value={buttonOne.Title}
//       />
//     </Form.Item>
//     <Form.Item label="Button Body" name="BodyOne">
//       <Input
//         type="text"
//         name="Body"
//         onChange={e =>
//           setButtonOne({ ...buttonOne, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonOne.Body}
//         value={buttonOne.Body}
//       />
//     </Form.Item>
//     <Form.Item label="Button Icon" name="IconOne">
//       <Input
//         type="text"
//         name="Icon"
//         onChange={e =>
//           setButtonOne({ ...buttonOne, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonOne.Icon}
//         value={buttonOne.Icon}
//       />
//     </Form.Item>
//     <Form.Item label="Button Url" name="UrlOne">
//       <Input
//         type="text"
//         name="Url"
//         onChange={e =>
//           setButtonOne({ ...buttonOne, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonOne.Url}
//         value={buttonOne.Url}
//       />
//     </Form.Item>

//     {/* Button 2 */}
//     <Typography.Title level={4}>Button 2</Typography.Title>
//     <Form.Item label="Button Title" name="TitleTwo">
//       <Input
//         type="text"
//         name="Title"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Title}
//         value={buttonTwo.Title}
//       />
//     </Form.Item>
//     <Form.Item label="Button Body" name="BodyTwo">
//       <Input
//         type="text"
//         name="Body"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Body}
//         value={buttonTwo.Body}
//       />
//     </Form.Item>
//     <Form.Item label="Button Icon" name="IconTwo">
//       <Input
//         type="text"
//         name="Icon"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Icon}
//         value={buttonTwo.Icon}
//       />
//     </Form.Item>
//     <Form.Item label="Button Url" name="UrlTwo">
//       <Input
//         type="text"
//         name="Url"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Url}
//         value={buttonTwo.Url}
//       />
//     </Form.Item>

//     <Divider />

//     <Button onClick={handleAddCustomizableButton} icon={<PlusOutlined />}>
//       Add Customizable Button
//     </Button>

//     {/* Button 3 */}
//     <Typography.Title level={4}>Button Three</Typography.Title>
//     <Form.Item label="Button Title" name="TitleThree">
//       <Input
//         type="text"
//         name="Title"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Title}
//         value={buttonTwo.Title}
//       />
//     </Form.Item>
//     <Form.Item label="Button Body" name="BodyThree">
//       <Input
//         type="text"
//         name="Body"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Body}
//         value={buttonTwo.Body}
//       />
//     </Form.Item>
//     <Form.Item label="Button Icon" name="IconThree">
//       <Input
//         type="text"
//         name="Icon"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Icon}
//         value={buttonTwo.Icon}
//       />
//     </Form.Item>
//     <Form.Item label="Button Url" name="UrlThree">
//       <Input
//         type="text"
//         name="Url"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Url}
//         value={buttonTwo.Url}
//       />
//     </Form.Item>

//     {/* Button 4 */}
//     <Typography.Title level={4}>Button Four</Typography.Title>
//     <Form.Item label="Button Title" name="TitleFour">
//       <Input
//         type="text"
//         name="Title"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Title}
//         value={buttonTwo.Title}
//       />
//     </Form.Item>
//     <Form.Item label="Button Body" name="BodyFour">
//       <Input
//         type="text"
//         name="Body"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Body}
//         value={buttonTwo.Body}
//       />
//     </Form.Item>
//     <Form.Item label="Button Icon" name="IconFour">
//       <Input
//         type="text"
//         name="Icon"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Icon}
//         value={buttonTwo.Icon}
//       />
//     </Form.Item>
//     <Form.Item label="Button Url" name="UrlFour">
//       <Input
//         type="text"
//         name="Url"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Url}
//         value={buttonTwo.Url}
//       />
//     </Form.Item>

//     {/* Button 5 */}
//     <Typography.Title level={4}>Button Five</Typography.Title>
//     <Form.Item label="Button Title" name="TitleFive">
//       <Input
//         type="text"
//         name="Title"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Title}
//         value={buttonTwo.Title}
//       />
//     </Form.Item>
//     <Form.Item label="Button Body" name="BodyFive">
//       <Input
//         type="text"
//         name="Body"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Body}
//         value={buttonTwo.Body}
//       />
//     </Form.Item>
//     <Form.Item label="Button Icon" name="IconFive">
//       <Input
//         type="text"
//         name="Icon"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Icon}
//         value={buttonTwo.Icon}
//       />
//     </Form.Item>
//     <Form.Item label="Button Url" name="UrlFive">
//       <Input
//         type="text"
//         name="Url"
//         onChange={e =>
//           setButtonTwo({ ...buttonTwo, [e.target.name]: e.target.value })
//         }
//         defaultValue={buttonTwo.Url}
//         value={buttonTwo.Url}
//       />
//     </Form.Item>

//     <Form.Item wrapperCol={{ offset: 3, span: 12 }}>
//       <Button
//         type="primary"
//         htmlType="submit"
//         disabled={
//           ((!buttonOne.Title ||
//             !buttonOne.Body ||
//             !buttonOne.Icon ||
//             !buttonOne.Url) &&
//             (!buttonTwo.Title ||
//               !buttonTwo.Body ||
//               !buttonTwo.Icon ||
//               !buttonTwo.Url)) ||
//           isLoading
//         }
//       >
//         Save Changes{' '}
//         {isLoading && (
//           <i className="fa fa-spinner fa-pulse fa-fw text-icon" />
//         )}
//       </Button>
//     </Form.Item>
//   </Form>
// );

export default CustomizableButtonsForm;
